import React from 'react';
import { Link } from 'react-router-dom';
import { Users, ShieldCheck, UserPlus, Flag } from 'lucide-react';

const AdminDashboardPage = () => (
  <div>
    <h1 className="font-heading font-bold text-2xl text-slate-900 mb-6">Admin Dashboard</h1>
    <div className="grid sm:grid-cols-2 gap-4">
      <Link
        to="/admin/users"
        className="p-6 rounded-xl bg-white border border-slate-200 hover:shadow-md transition-shadow flex items-center gap-4"
      >
        <Users className="h-8 w-8 text-primary" />
        <span className="font-medium text-slate-800">User management</span>
      </Link>
      <Link
        to="/admin/verification"
        className="p-6 rounded-xl bg-white border border-slate-200 hover:shadow-md transition-shadow flex items-center gap-4"
      >
        <ShieldCheck className="h-8 w-8 text-primary" />
        <span className="font-medium text-slate-800">Verification</span>
      </Link>
      <Link
        to="/admin/fake-profiles"
        className="p-6 rounded-xl bg-white border border-slate-200 hover:shadow-md transition-shadow flex items-center gap-4"
      >
        <UserPlus className="h-8 w-8 text-primary" />
        <span className="font-medium text-slate-800">Fake profiles</span>
      </Link>
      <Link
        to="/admin/reports"
        className="p-6 rounded-xl bg-white border border-slate-200 hover:shadow-md transition-shadow flex items-center gap-4"
      >
        <Flag className="h-8 w-8 text-primary" />
        <span className="font-medium text-slate-800">Reports</span>
      </Link>
    </div>
  </div>
);

export default AdminDashboardPage;
